import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/service/common.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  constructor(public cm:CommonService) { }

  ngOnInit() {
  }

  emailInput;
  passwordInput;
  loading = false;
  login(){
    this.loading = true;
    const url = '/v1.0/oauth/token';
    if(this.cm.checkinput(this.emailInput,'>',3) && this.cm.checkinput(this.passwordInput,'>',5)){
      const body = {
          "client_id": 'web',
          "username": this.emailInput,
          "password": this.passwordInput,
          "grant_type": "password",
          "account_type": "staff"
      }
      this.cm.postHtppLogin(url,body).then((res)=>{
        console.log(res);
        this.loading = false;
        this.cm.toastr.success('เข้าสู่ระบบสำเร็จ','สำเร็จ');
        sessionStorage.setItem('config',JSON.stringify(res));
        this.cm.goto('dashboard');
      }).catch((err)=>{
        console.log(err);
        this.loading = false;
        this.passwordInput = '';
        this.cm.toastr.warning('ชื่อผู้ใช้งานหรือรหัสผ่านไม่ถูกต้อง','แจ้งเตือน');
      })
    } else {
      this.loading = false;
      this.emailInput = '';
      this.passwordInput = '';
      this.cm.toastr.warning('มีบางอย่างผิดปกติ','แจ้งเตือน');
    }
  }
}
